var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "#3F2E00"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.444 7.5 4.156 3.213a.684.684 0 0 1-.211-.518.73.73 0 0 1 .226-.518.708.708 0 0 1 .518-.219c.2 0 .372.073.517.22l4.477 4.49c.117.117.205.249.263.395.058.145.087.291.087.437a1.17 1.17 0 0 1-.35.831l-4.491 4.492a.675.675 0 0 1-.51.212.725.725 0 0 1-.511-.227.708.708 0 0 1-.219-.518c0-.2.073-.372.219-.517L8.444 7.5Z"
  })));
};
export default SvgArrowRight;